import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  isOpen: false,
};
const navbarSlice = createSlice({
  name: 'btn',
  initialState,
  reducers: {
    toggleBtn: (state: any) => {
      state.isOpen = !state.isOpen;
    },
    // restocked: (state, action) => {
    //     state.numberOfCakes += action.payload;
    // }
  },
});

export default navbarSlice.reducer;
export const { toggleBtn } = navbarSlice.actions;
